<div
	mat-dialog-content
	class="flex flex-col">
	<mat-form-field
		appearance="outline"
		class="w-full">
		<mat-label>{{ "ERROR-REPORT_COMMENT" | translate }}</mat-label>
		<input
			matInput
			[(ngModel)]="data.error"
			[disabled]="true" />
		<mat-icon matIconPrefix>error</mat-icon>
	</mat-form-field>
	<mat-form-field
		appearance="outline"
		class="w-full">
		<mat-label>{{ "ERROR-REPORT_NOTES" | translate }}</mat-label>
		<input
			matInput
			[(ngModel)]="notes" />
		<mat-icon matIconPrefix>feedback</mat-icon>
	</mat-form-field>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		mat-dialog-close>
		{{ "core.close" | translate }}
	</button>
	@if (isLoading) {
		<mat-spinner
			color="primary"
			[diameter]="40" />
	}
	@if (!isLoading) {
		<button
			mat-raised-button
			color="primary"
			(click)="apply()">
			{{ "core.send" | translate }}
		</button>
	}
</div>
